export const PACKAGING_PENDING = "PACKAGING_PENDING";
export const PACKAGING_REJECTED = "PACKAGING_REJECTED";
export const PACKAGING_FULFILLED = "PACKAGING_FULFILLED";



// WEBPACK FOOTER //
// ./src/constants/packaging.js